module.exports = __webpack_public_path__ + "static/media/skeleton_wizard_robe.a05beaca.png";